
export default {
  path: 'scoreinput',
  name: 'event.discipline.scoreinput',
  component: () => import(/* webpackChunkName: "event" */ './scoreWrapper.vue'),
}
